<template>
  <div class="zz-item-box">
    <img
      class="zz-cover"
      :src="
        cover
          ? $global.imgUrl + cover
          : require('@/assets/img/mobile-img/zz_default.png')
      "
      alt=""
    />
    <div class="zz-item-content">
      <h3 v-html="title"></h3>
      <div
        v-if="artSummary"
        class="zz-item-artSummary"
        v-html="$global.matchReg(artSummary)"
      ></div>
      <div class="zz-item-author">
        <span v-html="author"></span> {{ timeStr }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // 标题 摘要 作者 刊名 刊期
  props: ["title", "artSummary", "author", "cover", "timeStr"],
  data() {
    return {
      searchStr: "",
    };
  },
  computed: {
    // highLightTitle() {
    //   return this.title.replaceAll(
    //     this.searchStr,
    //     `<span style="color:#517EF2">${this.searchStr}</span>`
    //   );
    // },
    /*
    highLightArtSummary() {
      return this.artSummary.replaceAll(
        this.searchStr,
        `<span style="color:#517EF2">${this.searchStr}</span>`
      );
    },

    highLightAuthor() {
      return this.author.replaceAll(
        this.searchStr,
        `<span style="color:#517EF2">${this.searchStr}</span>`
      );
    },
    */
  },
};
</script>

<style scoped lang="scss">
.zz-item-box {
  display: flex;
  margin-top: 15px;
  padding-bottom: 15px;
  .zz-cover {
    flex: 0 0 auto;
    margin-right: 12px;
    width: 90px;
    height: 90px;
    object-fit: contain;
    border: 1px solid #eeeeee;
    border-radius: 4px;
  }
  .zz-item-content {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    overflow: hidden;
    h3 {
      font-size: 15px;
      line-height: 21px;
      color: #333333;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .zz-item-artSummary {
      font-size: 13px;
      line-height: 21px;
      color: #999999;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .zz-item-author {
      font-size: 13px;
      line-height: 21px;
      color: #999999;
    }
  }
}
</style>
